import type { AuthUser } from '../../auth/models/auth.models';
import { ActiveLicense } from '../../school-license/models/school-license.model';
import { SchoolRole } from '../../school-users/models/school-user.model';

export interface School {
  id: string;
  name: string;
  isMinorityLanguageSchool: boolean;
  activeLicense: ActiveLicense | null;
  /**
   * The signed-in user's role in this school — the one caller-relative field on the record.
   * `null` means no membership at all, which is the ordinary case for a system admin: they see
   * every school but belong to none, so it must not be read as "not an admin".
   */
  schoolRole: SchoolRole | null;
}

/** `schoolRole` describes the caller, not the school, so it is never sent back on a write. */
export type SchoolData = Omit<School, 'id' | 'activeLicense' | 'schoolRole'>;

/**
 * Whether the user may act as an administrator of this school. A rendering hint only — every
 * guarded call is re-checked by the server, which still answers `403`.
 */
export function canAdministerSchool(user: AuthUser | null, school: School | null): boolean {
  if (!user) return false;
  return user.role === 'admin' || school?.schoolRole === 'admin';
}
